import { identity } from 'ramda';
import React, { Component } from 'react';
import Inputs from '../../Common/Inputs/Inputs';
import './SearchFrame.scss';

class SearchFrame extends Component {
  render() {
    const {
      validation = [],
      children,
      onInputSearchChange,
      countSelectedItems,
      selectedTitle = '',
      search,
      title,
      totalCountItems,
      selectAll,
      clearAll,
      searchScrollRef,
      errorMessages,
    } = this.props;

    return (
      <Inputs
        classNames="search-frame"
        autoComplete="off"
        errorMessages={errorMessages}
        required
        id={this.props.id}
        onInputChange={onInputSearchChange}
        title={title}
        name="search"
        type="search"
        placeholder="Search..."
        value={search}
        keepLabelTopAligned
        renderInput={({ renderDefaultInput }) => (
          <React.Fragment>
            {renderDefaultInput()}
            <div
              tabIndex={-1}
              aria-describedby={'casAssUserError'}
              ref={searchScrollRef}
              className={["search-checklist se-content pTop-5", errorMessages ? 'border-error' : null].filter(identity).join(' ')}>
              {children}
            </div>
          </React.Fragment>
        )}
        renderCustomErrors={({ errClass }) => (
          <div className="search-details-links">
            <div
              hidden={errorMessages}
              aria-live="polite"
              className="label-text ScalaSansOT">{`${countSelectedItems} ${selectedTitle} selected`}</div>
            <div
              hidden={!errorMessages}
              aria-live="alert"
              id={'casAssUserError'}
              className={errClass}>{`Please select ${selectedTitle}`}</div>
            <div className="frame-links-bellow">
              <span
                role="button"
                tabIndex={0}
                className={`${countSelectedItems === totalCountItems ? 'disabled' : 'active'}`}
                onClick={selectAll}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    selectAll();
                  }
                }}>
                Select all
              </span>
              |
              <span
                role="button"
                tabIndex={0}
                className={countSelectedItems ? 'active' : 'disabled'}
                onClick={clearAll}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    clearAll();
                  }
                }}>
                Clear all
              </span>
            </div>
          </div>
        )}
      />
    );
  }
}

export default SearchFrame;
